import React from "react";
import Slider from "react-slick";
const HomeSlider = () => {
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 5000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    adaptiveHeight: true,
  };
  return (
    <>
      <div className="slider-sec">
        <Slider {...settings}>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/slide1.jpg"
              className="d-block w-100"
              alt="GHSS"
            />
          </div>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/slide2.jpg"
              className="d-block w-100"
              alt="GHSS"
            />
          </div>
          <div className="item">
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/slide5.jpg"
              className="d-block w-100"
              alt="GHSS"
            />
          </div>
        </Slider>
      </div>
    </>
  );
};

export default HomeSlider;
